import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
// @ts-expect-error
import qs from 'qs';

import TextField from 'app/commonComponents/TextField';
import {
  FormColumn,
  FormRowGroup,
} from 'modules/tickets/components/common/dialog/TicketFormUtils';
import { Title, SubTitle } from './styles/WithdrawalStyles';
import form from 'modules/ticketPublicPage/stores/vouchers/form';

import InfoTooltip from 'app/components/InfoTooltip';
import { colors } from 'app/variables';
import InlineAlert from 'app/commonComponents/InlineAlert';

export const textFieldLabelStyle = {
  fontSize: '0.75rem',
  fontWeight: 'initial',
  color: colors.dustyGray,
};

const textFieldStyle = {
  width: '100%',
  marginBottom: 0,
};

const WithdrawalInitial = observer(() => {
  const { formValues, errors, setFormValue, validateField, serverError } = form;

  useEffect(() => {
    const {
      email,
      name,
      ref_num: refNum,
    } = qs.parse(window.location.search.slice(1));

    if (typeof email === 'string' && email.trim()) {
      setFormValue('withdrawal_email', email.trim());
    }

    if (typeof name === 'string' && name.trim()) {
      setFormValue('withdrawal_name', name.trim());
    }

    if (typeof refNum === 'string' && refNum.trim()) {
      setFormValue('withdrawal_code', refNum.trim());
    }
  }, [setFormValue]);

  return (
    <FormRowGroup style={{ width: '100%', marginBottom: '6.5rem' }}>
      <FormColumn style={{ width: '100%' }}>
        <Title>{i18n.gettext('Cancel the contract')}</Title>
        <SubTitle>
          {i18n.gettext(
            'You have 14 days to cancel your purchase. If vouchers have already been used, you may be required to reimburse the value.'
          )}
        </SubTitle>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '1rem',
          }}
        >
          <TextField
            label={i18n.gettext('Voucher Code') + ' ' + '*'}
            required
            placeHolder={i18n.gettext('e.g. abc123')}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setFormValue('withdrawal_code', e.target.value)
            }
            onBlur={() => validateField('withdrawal_code')}
            value={formValues.get('withdrawal_code')}
            maxLength="32"
            error={errors.get('withdrawal_code') || !!serverError}
            labelStyle={textFieldLabelStyle}
            style={textFieldStyle}
          />
          <TextField
            label={
              <div>
                <span>{i18n.gettext('Full name (buyer)') + ' ' + '*'}</span>
                <InfoTooltip
                  height="1rem"
                  width="1rem"
                  tooltipStyles={{
                    fontSize: '0.65rem',
                    lineHeight: '1rem',
                    maxWidth: '12rem',
                  }}
                  description={i18n.gettext(
                    'Enter the full name of the person who made the purchase, as it appears on the voucher.'
                  )}
                />
              </div>
            }
            required
            placeHolder={i18n.gettext('e.g. John Smith')}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setFormValue('withdrawal_name', e.target.value)
            }
            onBlur={() => validateField('withdrawal_name')}
            value={formValues.get('withdrawal_name')}
            error={errors.get('withdrawal_name') || !!serverError}
            labelStyle={textFieldLabelStyle}
            style={textFieldStyle}
          />
          <TextField
            label={i18n.gettext('Email') + ' ' + '*'}
            required
            placeHolder={i18n.gettext('e.g. john.smith@example.com')}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setFormValue('withdrawal_email', e.target.value)
            }
            onBlur={() => validateField('withdrawal_email')}
            value={formValues.get('withdrawal_email')}
            error={errors.get('withdrawal_email') || !!serverError}
            labelStyle={textFieldLabelStyle}
            style={textFieldStyle}
          />
        </div>

        {serverError && typeof serverError === 'string' ? (
          <InlineAlert
            type="error"
            style={{ marginTop: '1rem', fontSize: '0.9rem' }}
          >
            <span>{serverError}</span>
          </InlineAlert>
        ) : null}
      </FormColumn>
    </FormRowGroup>
  );
});

export default WithdrawalInitial;
